<ion-header class="one-on-one-chat-modal__header ion-no-border">
  <ion-toolbar>
    <c-modal-header [title]="contact?.contactName" [isRoot]="true" />
  </ion-toolbar>
</ion-header>

<ion-content [cChatAutoScroll]="messages()">
  <ion-infinite-scroll position="top" [disabled]="loading() || !hasOlder()" (ionInfinite)="onLoadOlder($event)">
    <ion-infinite-scroll-content [loadingSpinner]="null">
      <c-spinner [loading]="loadingOlder()" />
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <div class="one-on-one-chat-modal__content">
    <!-- The intro opens the conversation, so it only shows once its first message is loaded. -->
    @if (!hasOlder()) {
      <p class="one-on-one-chat-modal__intro">{{ 'chat.intro' | transloco }}</p>
    }

    <c-loader [loading]="loading()">
      @if (error()) {
        <div class="one-on-one-chat-modal__error">
          <p class="one-on-one-chat-modal__error-text">{{ 'chat.error.load' | transloco }}</p>
          <c-button type="ghost" size="small" [fullWidth]="false" (action)="onRetryLoad()">
            {{ 'chat.retry' | transloco }}
          </c-button>
        </div>
      } @else {
        <div class="one-on-one-chat-modal__messages">
          @for (day of days(); track day.day.getTime()) {
            <p class="one-on-one-chat-modal__date">{{ day.day | longDate: 'long' : false }}</p>
            @for (message of day.messages; track message.id) {
              @if (message.id === firstUnreadMessageId()) {
                <p #unreadSeparator class="one-on-one-chat-modal__unread">{{ 'chat.new-messages' | transloco }}</p>
              }
              <c-one-on-one-chat-message [message]="message" (retry)="onRetrySend(message)" />
            }
          }
        </div>
      }
    </c-loader>
  </div>
</ion-content>

@if (!loading() && !error()) {
  <ion-footer class="one-on-one-chat-modal__footer ion-no-border">
    <ion-toolbar>
      <c-chat-composer [placeholder]="'chat.placeholder' | transloco" (send)="onSend($event)" />
    </ion-toolbar>
  </ion-footer>
}
